/** Demon entity state machine */
export const enum DemonState {
  Idle = 0,
  Attack = 1,
  Death = 2,
  Moving = 3,
}

/** Particle role for visual layering */
export const enum ParticleRole {
  Body = 0,   // dark mass particles
  Wisp = 1,   // trailing smoke wisps
  Ember = 2,  // glowing ember accents
  Eye = 3,    // burning eye glow
}

/** Runtime data for a single demon on the sphere surface */
export interface DemonData {
  // Sphere-surface position (unit normal)
  nx: number
  ny: number
  nz: number
  radius: number // cached sampleTerrainRadius

  // Orientation
  heading: number // radians in tangent plane

  // AI
  state: DemonState
  stateTimer: number
  health: number

  // Movement
  speed: number
  targetNx: number
  targetNy: number
  targetNz: number
}

/** Total particle count per demon */
export const DEMON_PARTICLE_COUNT = 1200

/** Entity height in local units (scaled at render time) */
export const DEMON_LOCAL_HEIGHT = 6
